// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"23b20fd6","455":"71d8c3da","977":"016aa293"}[chunkId] + ".chunk.js";
};